import React, { useEffect, useState, useRef } from 'react'
import { useFormik } from 'formik'
import { laterPaymentValidationSchema } from '../../../Validations/laterPaymentValidations'
import { updatePayment } from '../../../apis/paymentAPI'

const LaterPayment = ({ userName, userEmail, slug, setSuccess }) => {
  const [loading, setLoading] = useState(false)
  const [intialLater, setIntialLater] = useState({
    name: userName,
    email: userEmail,
    expectedDate: '',
    message: ''
  })
  const formik = useFormik({
    initialValues: intialLater,
    enableReinitialize: true,
    validationSchema: laterPaymentValidationSchema,

    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setSubmitting(true)
      setLoading(true)
      try {
        setLoading(true)
        await updatePayment(values,slug)
        setSuccess('Success')
      } catch (error) {
        console.log('e', error)
      }
      setSubmitting(false)
      setLoading(false)
    }
  })

  return (
    <>
      <h5>IBAN / SEPA Payment</h5>
      <div>
        <form onSubmit={formik.handleSubmit} className='row g-3'>
          <div class='col-md-6'>
            <label htmlFor='name'>Name*:</label>
            <input
              name='name'
              type='text'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              className='form-control'
              style={{ marginBottom: 17 }}
            />
            {formik.touched.name && formik.errors.name ? (
              <div className='text-danger'>{formik.errors.name}</div>
            ) : null}

            <label htmlFor='email'>Email*:</label>
            <input
              name='email'
              type='text'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              className='form-control'
              style={{ marginBottom: 17 }}
            />
            {formik.touched.email && formik.errors.email ? (
              <div className='text-danger'>{formik.errors.email}</div>
            ) : null}

            <label htmlFor='expectedDate'>Expected Payment Date*:</label>
            <input
              name='expectedDate'
              type='date'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.expectedDate}
              className='form-control'
            />
            {formik.touched.expectedDate && formik.errors.expectedDate ? (
              <div className='text-danger'>{formik.errors.expectedDate}</div>
            ) : null}
          </div>

          <div class='col-md-6'>
            <label htmlFor='message'>Message*:</label>
            <textarea
              name='message'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.message}
              className='form-control'
              rows={6}
            />
            {formik.touched.message && formik.errors.message ? (
              <div className='text-danger'>{formik.errors.message}</div>
            ) : null}
          </div>
          <button
            type='submit'
            disabled={formik.isSubmitting}
            className='btn btn-primary mb-3'
            style={{ width: 'auto' }}
          >
            Submit
          </button>
        </form>
      </div>
    </>
  )
}

export default LaterPayment
